import { Component } from 'vue';
import { createEventBus } from '@/messaging/event-bus';

export const layoutBus = createEventBus();

export interface OpenDrawerCommand {
  component: Component;
  props?: Record<string, any>;
  on?: Record<string, (...args: any[]) => void>;
  paddless?: boolean;
  closable?: boolean;
  width?: string;
}

export function openDrawer(command: OpenDrawerCommand): void {
  layoutBus.$emit('drawer.open', command);
}

export function closeDrawer(): void {
  layoutBus.$emit('drawer.close');
}
